import { isDefined } from "@clipboard-health/util-ts";

interface LogoProps {
  url?: string;
  float?: "left" | "right" | "none" | "inline-start" | "inline-end";
  display?: string;
  height?: string | number;
  width?: string | number;
  margin?: string;
}

export function ClipboardLogo(props: LogoProps) {
  const { url, float, display, height, width, margin } = props;

  let basePath = "/";
  if (isDefined(process.env.REACT_APP_BASE_PATH) && process.env.REACT_APP_BASE_PATH !== "") {
    basePath = process.env.REACT_APP_BASE_PATH;
  }

  const urlString = url ?? `${basePath}clipboard1_w.png`;
  return (
    <div
      className="logo"
      style={{
        float,
        display: display ?? "inline-block",
        height,
        width,
        background: `url("${urlString}") center center / contain no-repeat`,
        margin: margin ?? "0 0 0 0",
      }}
    />
  );
}

export function BunnyLogo(props: LogoProps) {
  const { url, float, display, height, width, margin } = props;

  let basePath = "/";
  if (isDefined(process.env.REACT_APP_BASE_PATH) && process.env.REACT_APP_BASE_PATH !== "") {
    basePath = process.env.REACT_APP_BASE_PATH;
  }

  const urlString = url ?? `${basePath}bunnyVerticalAgnostic.png`;
  return (
    <div
      className="logo"
      style={{
        float,
        display,
        height,
        width,
        background: `url("${urlString}") center center / contain no-repeat`,
        margin: margin ?? "0 0 0 0",
      }}
    />
  );
}
